export const getComponentPosition = (ref: React.MutableRefObject<HTMLDivElement | null>) => {
  const { top = 0, bottom = 0, left = 0, right = 0 } = ref?.current?.getBoundingClientRect() || {}
  return { top, bottom, left, right }
}

export const getComponentDimensions = (ref: React.MutableRefObject<HTMLDivElement | null>) => {
  const { clientHeight: height = 0, clientWidth: width = 0 } = ref?.current || {}
  return { height, width }
}
